// extracted by mini-css-extract-plugin
module.exports = {"container":"ReturnsContainer_container__gR_uw","findStoreButton":"ReturnsContainer_findStoreButton__s8zK8"};